import axios from 'axios'
// import { store } from '@/store'

export const baseURL = "http://109.234.78.252:8082";
export const httpClient = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
    },
})